class ExtLink {
	constructor(el) {
		if (el) {
			this.el = el;
			this.extModal = document.getElementById('interstitial-modal');
			this.continueButton = this.extModal.querySelector('.continueExt');
			this.closeButton = this.extModal.querySelector('.c-modal__inner_close');

			this.el.addEventListener('click', this.displayModal);
			this.closeButton.addEventListener('click', this.closeModal);

			document.addEventListener('keydown', this.handleKeyDown);
		}
	}

	handleKeyDown = (e) => {
		if (this.extModal.classList.contains('is-open')) {
			if (e.key !== 'Escape') {
				return;
			}

			this.extModal.classList.remove('is-open');
		}
	}

	displayModal = (e) => {
		e.preventDefault();
		const { target } = e;
		// Fixes an issue with the social media links in the header.
		if (target.tagName !== 'a') {
			target.href = target.closest('a').href;
		}
		const modalMessage = this.extModal.querySelector('.js-modalcontent .wp-block-classic-editor');

		modalMessage.innerHTML = '<h3>Attention!</h3><p>You are now leaving FIRDAPSEHCP.com.</p>';
		this.extModal.classList.add('is-open');

		const continueButton = this.extModal.querySelector('.continueExt');
		continueButton.href = target.href;
	}

	closeModal = () => {
		this.extModal.classList.remove('is-open');
	}
}

export function initExtLinks() {
	// Get all on page links. Exclude wistia links, mailto links, and tel links.
	const pageLinks = [...document.querySelectorAll(`a[href]:not([href*='wistia.com']):not([href^='mailto:']):not([href^='tel:'])`)]; // eslint-disable-line

	pageLinks.forEach((link) => {
		const linkHost = (link.host).replace(/http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/, '');

		if (linkHost !== (window.location.origin).replace(/http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/, '')) {
			link.classList.add('is-external-link');
		}
	});

	const extLinks = [...document.querySelectorAll('.is-external-link')];
	if (extLinks.length) {
		embark.components.extLinks = extLinks.map((el) => new ExtLink(el));
	}
}

initExtLinks();
